import { ProdutoCampoPersonalizado } from './produto-campo-personalizado';
import { ProdutoCampoPersonalizadoItem } from './produto-campo-personalizado-selecionado';

export class MenuProduto {
  idMenu: number;
  descricao: string;
  filhos?: MenuProduto[];
  esconderFilhos?: boolean = false;
  checado?: boolean = false;
  recuo?: number;
  superior?: number;
  idCampoPersonalizado?: number;
  campoPersonalizadoMontar?: ProdutoCampoPersonalizado;
  campoPersonalizado?: ProdutoCampoPersonalizadoItem;
  categoriasMenuLateral: number[];
  ativo: boolean;
  mostrarFiltroFaixaPreco: boolean;
  mostrarFiltroMarca: boolean;
  selecionado: boolean;
}
